<template>
  <div class="TvaAudioPlayer">
    <div
      class="TvaAudioPlayer__controls"
      :class="[{ touch: $tvaMq !== 'desktop' }, $tvaMq]"
    >
      <div class="TvaAudioPlayer__info" :class="[$tvaMq]" @click="clickInfo()">
        {{ content.audio.info }}
      </div>
      <div class="skip-button back" @click="goBack15">
        <svgicon
          class="icon-back-15"
          icon="icon-back-15"
          :width="$tvaMq !== 'desktop' ? '25' : '15'"
          :height="$tvaMq !== 'desktop' ? '25' : '15'"
        ></svgicon>
      </div>
      <div class="play-button" @click="play" v-if="!playing">
        <svgicon
          class="icon-play"
          icon="icon-play"
          width="15"
          height="15"
        ></svgicon>
      </div>
      <div class="play-button" @click="pause" v-if="playing">
        <svgicon
          class="icon-pause"
          icon="icon-pause"
          width="15"
          height="15"
        ></svgicon>
      </div>

      <div class="skip-button fw" @click="goForward15">
        <svgicon
          class="icon-fw-15"
          icon="icon-fw-15"
          :width="$tvaMq !== 'desktop' ? '25' : '15'"
          :height="$tvaMq !== 'desktop' ? '25' : '15'"
        ></svgicon>
      </div>
    </div>
    <div class="TvaAudioPlayer__trackname">{{ meta.name }}</div>
    <div
      v-if="$tvaMq !== 'desktop'"
      class="TvaAudioPlayer__progressbar-container"
    >
      <div
        class="TvaAudioPlayer__progressbar"
        :style="{ width: progressCalc.toFixed(2) + '%' }"
      ></div>
    </div>
    <div
      v-else
      class="TvaAudioPlayer__progressbar"
      :style="{ height: progressCalc.toFixed(2) + '%' }"
    ></div>
  </div>
</template>
<script>
import { Howl, Howler } from "howler";
import "@/compiled-icons/icon-back-15";
import "@/compiled-icons/icon-fw-15";
import "@/compiled-icons/icon-play";
import "@/compiled-icons/icon-pause";

const timeConverterInMs = string => {
  /**
   * To convert time expressed as string (mm:ss) into a number (ms)
   */
  return (
    (Number(string.split(":")[0]) * 60 + Number(string.split(":")[1])) * 1000
  );
};
export default {
  props: ["source", "start", "end", "meta", "testWatcher", "content"],
  data() {
    return {
      audio: undefined,
      playing: false,
      progress: 0,
      hasBegin: false,
      beginTiming: null,
      isDestroing: false
    };
  },
  mounted() {
    /**
     * Quando il componente è mounted, creiamo un oggetto Howl:
     * - src che arriva come props, il path dell'audio
     * - sprite: un oggetto contenente gli sprite ("pezzi di audio"),
     * in questo caso un unico sprite chiamato section che corrisponde
     * alla sezione di audio del canto in cui si parla della scena attuale
     */
    this.$nextTick(() => {
      this.generate();
    });
  },
  methods: {
    clickInfo() {
      this.$emit("clickInfo");
    },
    play() {
      const getProgress = () => {
        if (this.progress <= this.finish / 1000 && !this.isDestroing) {
          this.progress = this.audio.seek();
        } else {
          this.audio.stop();
          this.progress = 0;
          clearInterval(myTimer);
          this.hasBegin = false;
          this.playing = false;
        }
      };
      var myTimer = setInterval(() => getProgress(), 200);

      /**
       * Se è la prima volta che viene premuto play settiamo hasBegin a true
       * altrimenti ogni volta che verrà ripremuto play si farà ripartire l'audio
       * dall'inizio dello sprite "section"
       */
      if (!this.hasBegin) {
        this.audio.play("section");
        this.beginTiming = this.audio.seek();
        this.playing = true;
        this.hasBegin = true;
      } else {
        this.audio.play();
        this.playing = true;
      }
    },
    pause() {
      this.audio.pause();
      this.playing = false;
    },
    goBack15() {
      const sound = this.audio.pause();
      const currentSeek = sound.seek();
      const backTo = currentSeek - 15;
      if (backTo <= this.begin / 1000) {
        this.audio.seek(this.beginTiming);
        this.audio.play();
        return;
      }
      this.audio.seek(backTo);
      this.audio.play();
    },
    goForward15() {
      const sound = this.audio.pause();
      const currentSeek = sound.seek();
      const forwardTo = currentSeek + 15;
      const duration = this.audio.duration();
      if (forwardTo >= duration) {
        return;
      }
      this.audio.seek(forwardTo);
      this.audio.play();
    },
    generate() {
      this.audio = new Howl({
        src: this.source,
        rate: 1.0,
        sprite: {
          section: [this.begin, this.finish]
        },
        onend() {
          this.playing = false;
        }
      });
    }
  },
  computed: {
    begin() {
      return timeConverterInMs(this.start);
    },
    finish() {
      return this.end.length > 0
        ? timeConverterInMs(this.end)
        : this.begin + 100000;
    },
    progressCalc() {
      return this.progress === 0
        ? 0
        : ((this.progress * 1000 - this.begin) / (this.finish - this.begin)) *
            100;
    }
  },
  watch: {
    /* source() {
      this.playing = false;
      this.audio.pause();
      this.audio.unload();
      setTimeout(() => {
        this.generate();
      }, 0);
    }, */
    start() {
      this.playing = false;
      this.hasBegin = false;
      this.audio.pause();
      this.audio.unload();
      setTimeout(() => {
        this.generate();
      }, 0);
    },
    testWatcher() {
      if (!testWatcher) {
        this.playing = false;
        this.hasBegin = false;
        this.audio.pause();
        this.audio.unload();
      }
    }
  },
  beforeDestroy() {
    this.isDestroing = true;
    this.audio.pause();
    this.audio.unload();
    this.playing = false;
    this.hasBegin = false;
  }
};
</script>
<style lang="scss" scoped>
.TvaAudioPlayer {
  width: 100%;
  height: 52px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .mobile &,
  .tablet & {
    justify-content: space-between;
    margin-bottom: 35px;
    max-width: 300px;
  }

  z-index: $z-d;
  &__trackname {
    display: none;
  }
  &__progressbar {
    &-container {
      width: 100%;
      height: 4px;
      background-color: $white-50;
      position: relative;
    }
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: white;
    transition: all 0.2s ease;
  }
  &__controls {
    &.desktop {
      display: flex;
      flex-direction: column;
      justify-self: flex-end;
      margin-bottom: 10px;
      margin-top: auto;
      .skip-button {
        fill: $white-70;
        cursor: pointer;
        &:hover {
          fill: $white;
        }
      }
      .play-button {
        fill: $white-70;
        cursor: pointer;
        &:hover {
          fill: $white;
        }
      }
    }
    &.touch {
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      width: 100%;
      justify-content: center;
      margin-bottom: 10px;
      .skip-button {
        fill: $white-70;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.back {
          margin-right: 10px;
        }
        &.fw {
          margin-left: 10px;
        }
      }
      .play-button {
        fill: $white;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px solid $white;
        background-color: $black-10;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  &__info {
    &.desktop {
      transform: rotate(270deg) translate(5px, -25%);
      transform-origin: 0 0;
      color: $white-70;
      @include ButtonS;
      white-space: nowrap;
      position: absolute;
      text-decoration: underline;
      cursor: pointer;
      &:hover {
        color: $white;
      }
    }
    &.mobile,
    &.tablet {
      right: 0%;
      color: $white-70;
      @include ButtonS;
      white-space: nowrap;
      position: absolute;
      text-decoration: underline;
    }
  }
  .desktop & {
    height: 100%;
    width: 35px;
    padding: 0;
    border-right: 1px solid white;
    color: white;
    position: relative;
    display: flex;
    flex-direction: column;
    z-index: $z-d;
    &__trackname {
      position: absolute;
      top: 50%;
      left: 0%;
      transform-origin: 0 0;
      transform: rotate(270deg) translate(-55%, 25%);
      text-align: center;
      display: block;
      width: 300px;
      @include ButtonS;
      white-space: nowrap;
    }
    .button {
      width: 50%;
    }
    &__progressbar {
      width: 4px;
      position: absolute;
      bottom: -1px;
      left: 100%;
      background-color: white;
      transition: all 0.2s ease;
    }
  }
}
</style>
